import { render, staticRenderFns } from "./AnswerImageArea.vue?vue&type=template&id=87c8b6a4&scoped=true&"
import script from "./AnswerImageArea.vue?vue&type=script&lang=ts&"
export * from "./AnswerImageArea.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerImageArea.vue?vue&type=style&index=0&id=87c8b6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c8b6a4",
  null
  
)

export default component.exports